import { render } from "./pp-draw-numbers-crown.vue?vue&type=template&id=cf752cde"
const script = {}

import exportComponent from "../../../../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.16_vue@3.5.16_typescript@5.9.2__webpack@5.99.9_@swc+c_wdn4uuzbn7h75zdmcwelxa3jhq/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__